function moduleConfig(bbConfig, $translateProvider) {
    'ngInject';

    // Override default BookingBug translations
    $translateProvider.translations('en', {
        //PUBLIC_BOOKING.CLIENT_FORM.ADDRESS_3_LBL
        CORE:{
            ALERTS: {
                ALREADY_REGISTERED: "You have already registered with this email address. Return to the <a href='#login'>Log In</a> page to log in."
            }
        },
        PUBLIC_BOOKING: {
            CLIENT_FORM: {
                ADDRESS_4_LBL: 'Town',
                ADDRESS_5_LBL: 'County'
            },
            MAIN_ACCOUNT: {
                PURCHASE_HISTORY_TAB_HEADING: "Purchase History",
                CHANGE_PASSWORD_TAB_HEADING: "Change Password"
            },
            MEMBER_TERMINOLOGY: {
                "FIRST_NAME_LBL": "@:COMMON.TERMINOLOGY.FIRST_NAME",
                "LAST_NAME_LBL": "@:COMMON.TERMINOLOGY.LAST_NAME",
                "PHONE_LBL": "@:COMMON.TERMINOLOGY.PHONE",
                "EMAIL_LBL": "@:COMMON.TERMINOLOGY.EMAIL",
                "MOBILE_LBL": "@:COMMON.TERMINOLOGY.MOBILE",
            },
            EVENT: {
                "CUSTOMER_DETAILS_HEADING": "Account Details",
                "EVENT_SOLD_OUT_INFO": "Sorry, this event has sold out.",
            },
            EVENT_LIST: {
                PRICE_FROM: '{{min_ticket_price | pretty_price}} to {{max_ticket_price | pretty_price}}',
                FILTER: {
                    NO_FILTER_APPLIED: ''
                }
            },
            LOGIN: {
                "HEADING": "Log In"
            }
        },
        "MEMBER": {
            "MODAL": {
                "DELETE_BOOKING" : {
                    "TICKETS_LBL": "Tickets",
                    "CONFIRM_CANCEL_BTN": "Confirm Cancellation"
                }
            },
            "CHANGE_PASSWORD": {
                "CURRENT_PASSWORD_LBL": "Current Password",
                "NEW_PASSWORD_LBL": "Enter new password",
                "CONFIRM_NEW_PASSWORD_LBL": "Confirm new password",
                "CURRENT_PASSWORD_INCORRECT_ERR": "Incorrect password",
                "CURRENT_PASSWORD_REQUIRED_ERR": "Please enter your existing password",
                "NEW_PASSWORD_REQUIRED_ERR": "Please enter a new password",
                "PASSWORD_MISMATCH_ERR": "Passwords do not match",
                "PASSWORD_PATTERN_ERR": "Password must contain a minimum of 7 characters and 1 number"
            }
        }
    });
}

export default moduleConfig;


// WEBPACK FOOTER //
// ../src/public/main.config.js